/* tslint:disable */
/* eslint-disable */
/**
 * Agoda.PropertyOnboarding
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { CompanyDetails } from './company-details';
// May contain unused imports in some cases
// @ts-ignore
import type { ComplianceDetails } from './compliance-details';
// May contain unused imports in some cases
// @ts-ignore
import type { CountryDropdownItem } from './country-dropdown-item';
// May contain unused imports in some cases
// @ts-ignore
import type { DropdownItem } from './dropdown-item';
// May contain unused imports in some cases
// @ts-ignore
import type { HostDetails } from './host-details';

/**
 * 
 * @export
 * @interface ProfileData
 */
export interface ProfileData {
    /**
     * 
     * @type {number}
     * @memberof ProfileData
     */
    'hostType': ProfileDataHostTypeEnum;
    /**
     * 
     * @type {CompanyDetails}
     * @memberof ProfileData
     */
    'companyDetails': CompanyDetails;
    /**
     * 
     * @type {Array<ComplianceDetails>}
     * @memberof ProfileData
     */
    'ultimateOwners': Array<ComplianceDetails> | null;
    /**
     * 
     * @type {Array<ComplianceDetails>}
     * @memberof ProfileData
     */
    'governmentControls': Array<ComplianceDetails> | null;
    /**
     * 
     * @type {HostDetails}
     * @memberof ProfileData
     */
    'hostDetails': HostDetails;
    /**
     * 
     * @type {DropdownItem}
     * @memberof ProfileData
     */
    'preferredLanguage': DropdownItem;
    /**
     * 
     * @type {CountryDropdownItem}
     * @memberof ProfileData
     */
    'countryCode': CountryDropdownItem;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'email': string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfileDataHostTypeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}


